var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineDotted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "#939090",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.5a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0v-1zm-12 0a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0v-1zm8.5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 1 1 3 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineDotted);
export default __webpack_public_path__ + "static/media/line_dotted.dff1fca0bfbd23ebb423609e58394c3f.svg";
export { ForwardRef as ReactComponent };